import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-masters',
  templateUrl: './masters.component.html',
  styleUrls: ['./masters.component.css']
})
export class MastersComponent implements OnInit {

  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Masters')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/masters.component.ts